"use strict";
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2022 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.UrbitSocketServerEvents = exports.UrbitSocketClientEvents = exports.NativeSocketEvents = exports.ClientSocketEvents = exports.NotificationEvents = exports.ServerSocketEvents = void 0;
/* ------------------ Socket Event Types ------------------ */
var ServerSocketEvents;
(function (ServerSocketEvents) {
    // plate
    ServerSocketEvents["UserJoined"] = "USER_JOINED";
    ServerSocketEvents["UserLeft"] = "USER_LEFT";
    ServerSocketEvents["MouseBeacon"] = "MOUSE_BEACON";
    ServerSocketEvents["PresentUsers"] = "PRESENT_USERS";
    ServerSocketEvents["LockedBlocks"] = "LOCKED_BLOCKS";
    ServerSocketEvents["UnlockedBlocks"] = "UNLOCKED_BLOCKS";
    ServerSocketEvents["PlateUpdate"] = "PLATE_UPDATE";
    ServerSocketEvents["PageSavedReceipt"] = "PAGE_SAVED_RECEIPT";
    // notification
    ServerSocketEvents["Notification"] = "NOTIFICATION_ACTIVITY_POSTED";
})(ServerSocketEvents = exports.ServerSocketEvents || (exports.ServerSocketEvents = {}));
var NotificationEvents;
(function (NotificationEvents) {
    NotificationEvents["FOLLOW"] = "FOLLOW";
    NotificationEvents["PAGE_SHARED"] = "PAGE_SHARED";
    NotificationEvents["BLOCK_OR_PAGE_LIKE"] = "BLOCK_OR_PAGE_LIKE";
    NotificationEvents["ADMIN_ANNOUNCEMENT"] = "ADMIN_ANNOUNCEMENT";
})(NotificationEvents = exports.NotificationEvents || (exports.NotificationEvents = {}));
var ClientSocketEvents;
(function (ClientSocketEvents) {
    ClientSocketEvents["WhoIsHere"] = "who-is-here?";
    ClientSocketEvents["LockBlocks"] = "lock-blocks";
    ClientSocketEvents["UnlockBlocks"] = "unlock-blocks";
    ClientSocketEvents["MouseBeacon"] = "mouse-beacon";
    ClientSocketEvents["PlateUpdate"] = "plate-update";
})(ClientSocketEvents = exports.ClientSocketEvents || (exports.ClientSocketEvents = {}));
var NativeSocketEvents;
(function (NativeSocketEvents) {
    NativeSocketEvents["Connect"] = "connect";
    NativeSocketEvents["Disconnect"] = "disconnect";
    NativeSocketEvents["ConnectError"] = "connect_error";
})(NativeSocketEvents = exports.NativeSocketEvents || (exports.NativeSocketEvents = {}));
var UrbitSocketClientEvents;
(function (UrbitSocketClientEvents) {
    UrbitSocketClientEvents["ShipName"] = "ship-name";
})(UrbitSocketClientEvents = exports.UrbitSocketClientEvents || (exports.UrbitSocketClientEvents = {}));
var UrbitSocketServerEvents;
(function (UrbitSocketServerEvents) {
    UrbitSocketServerEvents["LogMessage"] = "log-message";
    UrbitSocketServerEvents["AuthApprovalUpdate"] = "auth-approval-update";
})(UrbitSocketServerEvents = exports.UrbitSocketServerEvents || (exports.UrbitSocketServerEvents = {}));
//# sourceMappingURL=types.js.map